function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
import { Constants } from '../utils/constants';
import { urlAssign } from './../routerHistory';
import { getWindow } from './../services/window';
import { logger } from '@src/logger';
export function getOverrideAttributes(props) {
    const isEmailLink = props.href.indexOf('mailto:') === 0;
    const overrideAttributes = {};
    // override attribute onClick event
    overrideAttributes.onClick = (event)=>{
        if (props.onClickHandle) {
            props.onClickHandle(event);
        }
        if (props.onClick) {
            props.onClick(event);
        }
        const detailText = isEmailLink ? 'External Link Clicked, Email Dialog opened' : 'External Link Clicked, New Tab opened';
        logTelemetry(Constants.Telemetry.Action.Click, Constants.Telemetry.ActionModifier.Link, detailText);
        logger.info(detailText, {
            action: Constants.Telemetry.Action.Click,
            actionModifier: Constants.Telemetry.ActionModifier.Link
        });
        event.preventDefault();
        // props.shouldOpenInTab is true as default
        const shouldOpenInTab = !isEmailLink && props.shouldOpenInTab !== false;
        urlAssign(props.href, shouldOpenInTab);
    };
    // override attribute tabIndex
    overrideAttributes.tabIndex = props.tabIndex || (props.accessibilityEnabled ? 0 : -1);
    return overrideAttributes;
}
export function getAttributes(props) {
    // override attributes
    const overrideAttributes = getOverrideAttributes(props);
    // attributes
    let attributes = {};
    Object.keys(props).filter((propName)=>[
            'children',
            'accessibilityEnabled',
            'onClickHandle',
            'shouldOpenInTab'
        ].indexOf(propName) < 0).forEach((propName)=>attributes[`${propName}`] = props[`${propName}`]);
    attributes = _object_spread({}, attributes, overrideAttributes);
    return attributes;
}
/**
 * log telemetry
 */ export function logTelemetry(action, actionModifier, details) {
    const pageUrl = getWindow() && getWindow().location && getWindow().location.href;
    const payload = {
        page: pageUrl,
        action: action,
        actionModifier: actionModifier
    };
    if (details) {
        const detailsName = 'details';
        payload[`${detailsName}`] = details;
    }
}
